import CachedIcon from '@mui/icons-material/Cached';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { alpha, Box, Button, Typography, useTheme } from '@mui/material';
import React from 'react';

import { ReactComponent as PreviewOffIcon } from '../../../../../assets/images/preview-off.svg';

interface IPreviewOffProps {
  onRetry: () => void;
  onOpenInNewTab: () => void;
}

export const PreviewOff: React.FC<IPreviewOffProps> = ({ onRetry, onOpenInNewTab }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, maxWidth: 367 }}>
      <Box sx={{ p: 3, backgroundColor: alpha(theme.palette.secondary.main, 0.08), borderRadius: 2 }}>
        <Box sx={{ width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <PreviewOffIcon />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 1 }}>
        <Typography variant="h6" color="text.primary">
          Preview unavailable
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We can't load this preview inside the builder right now. You can keep editing, or open it in a new tab.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, width: '100%' }}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<CachedIcon />}
          fullWidth
          onClick={onRetry}
          data-action="preview_retry_btn"
        >
          Retry
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<OpenInNewIcon />}
          fullWidth
          onClick={onOpenInNewTab}
          data-action="preview_open_in_new_tab_btn"
        >
          Open in new tab
        </Button>
      </Box>
    </Box>
  );
};
